import React from "react";
import {
  IDocumentUploadedResponse,
  ISubmitRequestBody,
  IUploadDocumentRequestBody,
  IUploadLivenessRequestBody,
} from "../types/api/application.type";
import {
  submitApplicationApi,
  uploadDocumentApi,
  uploadLivenessSelfieApi,
} from "../api/application";
import {
  LivenessCaptureStep,
  PrimaryDocumentCaptureStep,
  ResultsStep,
} from "../types/onboard";
import { handleApiError } from "../api/handleApiError";
import { SetError } from "../provider/ApiErrorProvider";
import { PrimaryDocumentErrorCodes } from "../types/document";
import { getUserDevice } from "../utils/helper";
export const handleLivenessPhotoTaken = <T>(
  id: string | undefined,
  handleLivenessCaptureStep: (val: number) => void,
  body: IUploadLivenessRequestBody,
  setResponseBody:React.Dispatch<React.SetStateAction<string>>,
  setError: SetError
) => {
  const UploadLivenessSelfie = async (id: string) => {
    try {
      const uploadedLivenessData = await uploadLivenessSelfieApi(id, body);
      if (uploadedLivenessData?.status === 200) {
        if (uploadedLivenessData?.data?.errorCode) {
          if(body.livenessType == "PASSIVE"){
            setResponseBody(uploadedLivenessData?.data?.errorMessage);
            handleLivenessCaptureStep(LivenessCaptureStep.ON_FAILURE); //on passive liveness failure to render active liveness
          } 
          else{
            /*
             * Active liveness has no retry, so the journey continues — but it
             * continued through the success screen, which claimed the selfie had
             * been captured and gave no sign the check had failed. The reviewer
             * sees the failed check; the applicant should too.
             */
            setResponseBody(uploadedLivenessData?.data?.errorMessage);
            handleLivenessCaptureStep(LivenessCaptureStep.ON_UNCONFIRMED);
          }
        } else {
          handleLivenessCaptureStep(LivenessCaptureStep.ON_SUCCESS);
        }
        setError(null);
      }
    } catch (error) {
      handleApiError(error,setError,() => UploadLivenessSelfie(id))
      console.error("Error in  uploading liveness selfie:", error);
    }
  };
  if (id) UploadLivenessSelfie(id);
};

export const handlePrimaryDocumentPhotoTaken = <T>(
  id: string | undefined,
  body: IUploadDocumentRequestBody,
  setDocumentIndex: React.Dispatch<React.SetStateAction<number>>,
  handlePrimaryDocumentCaptureStep: (stepNumber: number) => void,
  setDocumentUploadedResponse: React.Dispatch<React.SetStateAction<IDocumentUploadedResponse>>,
  setError: SetError,
  isSingleSidedDocument: boolean,
  handleContinueDetection: () => void
) => {
  const UploadDocument = async (id: string) => {
    try {
      const retake = sessionStorage.getItem("retake");
      const uploadedResponse = await uploadDocumentApi(id, retake, body);
      if (uploadedResponse?.status === 200) {
        sessionStorage.removeItem("retake");
        if (uploadedResponse?.data?.errorCode) {
          setDocumentIndex(body.imageType == "front" ? 0 : 1);
          if(uploadedResponse?.data?.errorCode === PrimaryDocumentErrorCodes.DOCUMENT_BARCODE_NOT_DETECTED 
            && getUserDevice() === "DESKTOP"
          ){
            handlePrimaryDocumentCaptureStep(
              PrimaryDocumentCaptureStep.ON_BARCODE_DETECTION_FAILURE
            );
          }
          else{
            handlePrimaryDocumentCaptureStep(
              PrimaryDocumentCaptureStep.ON_FAILURE
            );
          }
          setDocumentUploadedResponse(uploadedResponse.data);
        } else {
          if(body.imageType === "front" && !isSingleSidedDocument){
            setDocumentIndex(1);
            handleContinueDetection();
          }    
          else if(body.imageType === "back" || isSingleSidedDocument){
            setDocumentIndex(0);
            handlePrimaryDocumentCaptureStep(PrimaryDocumentCaptureStep.ON_SUCCESS);
          }      
        }
        setError(null);
      }
    } catch (error) {
      sessionStorage.removeItem("retake");
      handleApiError(error,setError,() => UploadDocument(id))
      console.error("Error in document creation or upload:", error);
    }
  };
  if (id) UploadDocument(id);
};


export async function submitCustomer(
  body: ISubmitRequestBody,
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>,
  setIsDisabled:React.Dispatch<React.SetStateAction<boolean>>,
  setError: SetError,
  setSubmitResponse: React.Dispatch<React.SetStateAction<{applicationId:string}>>
) {
  try{
    setIsDisabled(true)
    const submitCustomerResponse = await submitApplicationApi(body);
    if (submitCustomerResponse?.status == 201) {
      setSubmitResponse(submitCustomerResponse?.data);
      setError(null)
      setCurrentStep(ResultsStep.SUCCESSFULL_SUBMISSION);
      setIsDisabled(false)
    } else {
      setIsDisabled(false)
      console.error("Error submitting customer");
    }
  }
  catch(error){
    setIsDisabled(false)
    handleApiError(error,setError,() => submitCustomer(body,setCurrentStep,setIsDisabled,setError,setSubmitResponse));
  }
}
